import Invoice from "../../model/invoice/Invoice";
import {option, Option} from "ts-option";
import {RootState} from "../reducer/root/RootState";
import {objectIterator} from "../../utils/DictionaryUtils";
import {store} from "../../navigation/ReduxProvider";

/**
 * Get invoice by job identifier.
 * @param {string} jobId Job identifier.
 * @param {RootState} state State of the redux.
 */
export function getInvoiceByJobId(jobId: string, state: RootState): Option<Invoice> {
	const invoicesMap = state.invoice.invoicesMap;
	const invoice = invoicesMap[jobId];
	return option(invoice);
}

/**
 * Get invoice by its identifier.
 * @param {string} invoiceId invoice identifier.
 * @returns {Option<Invoice>}
 */
export function getInvoiceById(invoiceId: string): Option<Invoice> {
	const invoicesAsArray = objectIterator(store.getState().invoice.invoicesMap);
	const [invoice] = invoicesAsArray.filter(inv => inv.id === invoiceId);
	return option(invoice);
}
